/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React,{useContext, useState,useEffect,useCallback} from 'react'
import AddAssociationTopSection from './AssociationComponents/AddAssociationTopSection'
import AssociationSection from './AssociationComponents/AssociationSection';
import CardHeader from '../../../components/CardHeader';
import Loader from '../../../components/Loader';
import { useNavigate } from 'react-router-dom';
import Toast from '../../../components/Toast';
import GlobalContext from '../../../components/Context/GloablContext';
import { useSelector } from 'react-redux';
import { dataService } from '../../../services/data.services';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import CustomOverLay from '../../../components/CustomOverlay';


export default function AddAssociation({edit}) {
    const [editData, seteditData] = useState({})
    const {setToastmessage} =useContext(GlobalContext)
    const location=useNavigate()
    const [state, setstate] = useState({
        association:[]
    });
    const Association=useSelector(state=>state.Association);
    const {year,class_name}=Association.selectedDropdown
    const [loading, setloading] = useState(false)
    const [submitSelected, setsubmitSelected] = useState(false)
    const handleRemove=(item,id,name)=>{
        const stateCopy={...state}
        const idx=stateCopy.association?.map(val =>val[id]).indexOf(item._id ||item[id]);
      

    }
    const handleAddSection=(item,id,name)=>{
        setsubmitSelected(false)
        setToastErrorMessage('')
        const stateCopy={...state}
        const idx=stateCopy.association?.map(val =>val[id]).indexOf(item._id || item[id]);
        if(idx===-1){
            stateCopy.association?.push({
                [id]: item[['_id']],
                [name]: item.name,
                exams:[],
                teachers:[],
                subjects:[]

            })

        }else{
            stateCopy.association?.splice(idx,1)
        }
        setstate(stateCopy)
        
    }
    const selectAssociation=(item,id,name,type,index)=>{
        setsubmitSelected(false)
        const key=type.toLowerCase()
        const stateCopy={...state}
        const idx=stateCopy.association[index][key]?.map(val =>val[id]).indexOf(item._id || item[id]);
        if(idx===-1){
            stateCopy.association[index][key].push({
                [id]: item[['_id']],
                [name]: item.name,
               
            })

        }else{
            stateCopy.association[index][key].splice(idx,1)
        }
        setstate(stateCopy)

    }
    const [toastErrorMessage, setToastErrorMessage] = useState('');

    //validdation

    const handleValidation=()=>{
        let arr=[];
        Object.keys(state.association).map((val)=>{
            Object.keys(state.association[val]).map((key)=>{
                if(typeof state.association[val][key] ==='object' && state.association[val][key]?.length===0){
                    arr.push(key)

                }
            })
           
        })
        return arr?.length===0
    }

    const handleSubmit=async(e)=>{
        e.preventDefault();
        setloading(true)
        setsubmitSelected(true);
        if(state.association?.length===0){
            setToastErrorMessage('Please select a section first');
            setloading(false)

            return

        }
        // if(!handleValidation()){
        //     setToastErrorMessage(`Please fill out both 'Sections & Teachers' and 'Subjects & Exams' before proceeding.`);
        //     setloading(false)

        //     return

        // }
        const branch_id = await GetBranchId()

        let responseBody
        if(edit){
            responseBody=state.association.map((obj)=>({
                exams:obj.exams,
                section_id:obj.section_id,
                section_name:obj.section_name,
                subjects:obj.subjects,
                teachers:obj.teachers
    
            }))
        }
        else{
            responseBody=state.association
        }
        const Payload={
            "branch_id": branch_id,
            "academic_year": {
                "name": year.name,
                "start_date": year.start_date,
                "end_date": year.end_date,
                "academic_year_id" : year._id,
            },
            "class_name": class_name.name,
            "class_id": class_name._id,
            association:responseBody

        }
        let response;
        let endpoint;
        try {
            if(edit) {
                endpoint=`associations/`
                response = await dataService.PatchAPI(Payload,endpoint);
            } else {
                endpoint=`associations`
                response = await dataService.PostAPI(Payload,endpoint);
            }
            if (response.data.status===201 || response.error === false) {
                setToastmessage(`Association ${edit ? 'updated': 'added'} successfully`)
                setloading(false);                
                location('/employee-master/manage-association');

            }
            else {
                debugger
                setloading(false);
                setToastErrorMessage(response.data.message)
            }

            
        } catch (error) {
            console.log(error)
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message ||'Something went wrong')
            
        }
    }
    const handleFetch =useCallback(
        async() => {
            const branch_id = await GetBranchId()
            let response = await dataService.GetAPI(`associations?branch_id=${branch_id}&filter=true&academic_year_id=${year._id}&class_id=${class_name._id}&filter=true`);
            if(response.data.status===200){
                const Getdata=response.data.data
                seteditData(JSON.parse(JSON.stringify(Getdata)))
                setstate((prev)=>({
                    ...prev,
                    association:Getdata.data?.map((obj)=>({...obj,_id:obj.section_id}))
                }))
            }

        },
        [],
    )
    
    
    useEffect(() => {
        if(Object.keys(year)?.length===0|| Object.keys(class_name)?.length==0){
            location('/employee-master/manage-association');
        }
        if(edit &&Object.keys(year)?.length>0&& Object.keys(class_name)?.length>0)
            handleFetch()
      
    }, [])

    return (
        <CardHeader noPadding>

            {toastErrorMessage!=='' &&<Toast
                message={toastErrorMessage}
                type="error"
                setToastmessage={setToastErrorMessage} />}
            <form onSubmit={(e)=>handleSubmit(e)}>
                <div className="mainDataCntnrTop shadow-s13">
                    <h5 className="pageHeader adderror">{edit?'Edit':'Add'} Association</h5>
                    <div class="flex items-center">
                        <button onClick={()=>location('/employee-master/manage-association')} type="button" class="cancl-btn">
                            Cancel
                        </button>
                        <button 
                            disabled={ loading || (edit&&Object.keys(editData)?.length===0)}
                            type="submit"
                            id='sumbit-button'
                            style={{'width':loading?'96px':'auto'}}
                            class="actn-btn onboardInstitution">
                            {!loading?edit?'Update':'Add':<span>{<Loader />}</span>}  
                        </button>
                    </div>
                </div>
                {edit && Object.keys(editData)?.length===0 && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
                <div className="mainDataCntnrPageDiv scrollBlue_thick">
                    <div className="display">
                        <div className="px-2 py-2 border border-[#c2dcef] rounded-sm mb-4 bg-blue-50 bg-opacity-75" >
                            <ul className="list-disc pl-6">
                                <li className="text-f7 font-normal text-[#000000]">
                                    Please select the Section(s) to associate Teachers, Subjects, and Exams for the selected ‘Academic Year’ and ‘Class’.
                                </li>
                                <li className="text-f7 font-normal text-[#000000]">
                                    For each Section, choosing subjects is necessary to list them under 'Academic Details' while adding a Student.
                                </li>
                            </ul>
                        </div>
                        <AddAssociationTopSection 
                            handleAddSection={handleAddSection}
                            state={state}
                            setstate={setstate}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            handleRemove={()=>{}}
                            edit={edit}
                        />
                        {state?.association?.length>0 &&<AssociationSection 
                            state={state}
                            setstate={setstate}
                            handleAddSection={selectAssociation}
                            handleRemove={()=>{}}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}

                        />}
                    </div>
                </div>
            </form>
        </CardHeader>

    )
}
